import { render, staticRenderFns } from "./PublicPageMenuEntry.vue?vue&type=template&id=7256a1f8&scoped=true"
import script from "./PublicPageMenuEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./PublicPageMenuEntry.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PublicPageMenuEntry.vue?vue&type=style&index=0&id=7256a1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7256a1f8",
  null
  
)

export default component.exports